import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {GetUserResponse} from "../../../config/types";

const initialState:GetUserResponse = {message:'',data:[]}

export const state = createSlice({
  name: "users",
  initialState,

  reducers: {
    addUsers: (_state, action: PayloadAction<GetUserResponse>) => {
   return action.payload
    },
  },
});

export const { addUsers } = state.actions;

export default state.reducer;
